import React, { useCallback } from 'react';

import classnames from 'classnames';

import HorizontalScroller from 'components/uiLibrary/HorizontalScroller';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';

import { SUB_COMPONENTS } from 'components/Globals/Analytics/constants';
import EntityProfileSelector, { VARIANTS } from 'components/Globals/EntityProfileSelector';

import useNavigate from 'utils/hooks/useNavigate';
import usePageContext from 'utils/hooks/usePageContext';

import { FILTER_TYPES, ROUTE_RESERVED_KEYWORDS } from 'operabase-router/constants';

import classes from './EntitySectionFilters.module.scss';

const EntitySectionFilters = ({
  allowedEntityTypes,
  children,
  trackingData = {},
  isComposer = false,
  skipSearchCollapse = false,
}) => {
  const navigate = useNavigate();
  const { applyFilters } = usePageContext();

  const onSearch = useCallback(
    query => {
      const hasMultipleEntityTypes = allowedEntityTypes.length > 1;

      if (isComposer) {
        navigate.to(
          navigate.getLinkProps({
            basePath: ROUTE_RESERVED_KEYWORDS.composers,
            filters: {
              [FILTER_TYPES.QUERY]: query,
            },
          }),
        );
      } else if (hasMultipleEntityTypes) {
        navigate.to(
          navigate.getLinkProps({
            basePath: ROUTE_RESERVED_KEYWORDS.search,
            filters: {
              [FILTER_TYPES.QUERY]: query,
            },
          }),
        );
      } else {
        applyFilters({
          entityType: allowedEntityTypes[0],
          filters: {
            [FILTER_TYPES.PAGE]: 1,
            [FILTER_TYPES.QUERY]: query,
          },
        });
      }
    },
    [allowedEntityTypes, navigate, applyFilters, isComposer],
  );

  const onChange = useCallback(
    ({ entity, entityType }) => {
      if (entity?.id && entityType) {
        navigate.to(
          navigate.getLinkProps({
            entityType,
            entity,
          }),
        );
      }
    },
    [navigate],
  );

  return (
    <HorizontalScroller hideArrow>
      <div className={classnames(classes.root, { [classes.root_searchCollapsible]: !skipSearchCollapse })}>
        <EntityProfileSelector
          className={classnames(classes.root__search, { [classes.root__search_field]: !skipSearchCollapse })}
          allowedEntityTypes={allowedEntityTypes}
          variant={VARIANTS.ROUNDED}
          trackingData={{
            ...trackingData,
            subComponent: SUB_COMPONENTS.ENTITY_PROFILE_SELECTOR,
          }}
          onChange={onChange}
          onSearch={onSearch}
          isComposer={isComposer}
        />
        {!skipSearchCollapse && (
          <div className={classes.root__search_icon}>
            <div className={classes.root__search_icon_inner}>
              <SpriteIcon icon="search" size={20} onClick={navigate.scrollTo} />
            </div>
          </div>
        )}
        {children}
      </div>
    </HorizontalScroller>
  );
};

export default EntitySectionFilters;
